import { useMemo, useEffect } from 'react';
import * as THREE from 'three';

const DEPTH = 60;
const THICKNESS = 3;

function roundedRectHole(cx, cy, w, h, r) {
  const x = cx - w / 2;
  const y = cy - h / 2;
  const path = new THREE.Path();
  path.moveTo(x + r, y);
  path.lineTo(x + w - r, y);
  path.absarc(x + w - r, y + r, r, -Math.PI / 2, 0, false);
  path.lineTo(x + w, y + h - r);
  path.absarc(x + w - r, y + h - r, r, 0, Math.PI / 2, false);
  path.lineTo(x + r, y + h);
  path.absarc(x + r, y + h - r, r, Math.PI / 2, Math.PI, false);
  path.lineTo(x, y + r);
  path.absarc(x + r, y + r, r, Math.PI, Math.PI * 3 / 2, false);
  path.closePath();
  return path;
}

export default function PianoCucina({ moduli }) {
  const totalWidth = useMemo(
    () => moduli.reduce((sum, m) => sum + m.larghezza, 0),
    [moduli]
  );

  const geometry = useMemo(() => {
    const shape = new THREE.Shape();
    shape.moveTo(-totalWidth / 2, -DEPTH / 2);
    shape.lineTo(totalWidth / 2, -DEPTH / 2);
    shape.lineTo(totalWidth / 2, DEPTH / 2);
    shape.lineTo(-totalWidth / 2, DEPTH / 2);
    shape.closePath();

    let cursorX = -totalWidth / 2;
    for (const modulo of moduli) {
      if (modulo.foro) {
        const { larghezza: fw, profondita: fp, radius } = modulo.foro;
        const cx = cursorX + modulo.larghezza / 2;
        shape.holes.push(roundedRectHole(cx, 0, fw, fp, radius));
      }
      cursorX += modulo.larghezza;
    }

    const geo = new THREE.ExtrudeGeometry(shape, {
      depth: THICKNESS,
      bevelEnabled: false,
      curveSegments: 16,
    });

    // Centra lo spessore sull'asse Y, poi ruota in piano orizzontale
    geo.translate(0, 0, -THICKNESS / 2);
    geo.rotateX(-Math.PI / 2);
    geo.computeVertexNormals();

    return geo;
  }, [moduli, totalWidth]);

  useEffect(() => () => geometry.dispose(), [geometry]);

  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial color="#c8a882" side={THREE.DoubleSide} />
    </mesh>
  );
}
